import cn from 'classnames'
import React, { ComponentProps } from 'react'

type ArrowLeftProps = {
  className?: string
} & ComponentProps<'svg'>

export default function ArrowLeft(props: ArrowLeftProps) {
  const { className = '', ...rest } = props
  return (
    <svg
      className={cn('ArrowLeft', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.06912 4.63079C8.21436 4.43505 8.19822 4.15727 8.02071 3.97976C7.82545 3.7845 7.50887 3.7845 7.3136 3.97976L3.31344 7.97993L3.26503 8.03601C3.11979 8.23175 3.13593 8.50952 3.31344 8.68703L7.3136 12.6872L7.36968 12.7356C7.56542 12.8808 7.8432 12.8647 8.02071 12.6872L8.06912 12.6311C8.21436 12.4354 8.19822 12.1576 8.02071 11.9801L4.87443 8.83348H12.3337L12.4015 8.82891C12.6456 8.7958 12.8337 8.58661 12.8337 8.33348C12.8337 8.05733 12.6098 7.83348 12.3337 7.83348H4.87415L8.02071 4.68687L8.06912 4.63079Z"
        fill="currentColor"
      />
    </svg>
  )
}
